export const CREATE_NEW_POST= "CREATE_NEW_POST";
export const GET_USER_POST= "GET_USER_POST";
export const DELETE_POST= "DELETE_POST";
export const LIKE_POST="LIKE_POST";
export const UNLIKE_POST="UNLIKE_POST";
export const SAVE_POST="SAVE_POST";
export const UNSAVE_POST="UNSAVE_POST";
export const REQ_USER_POST="REQ_USER_POST";
export const GET_SINGLE_POST="GET_SINGLE_POST";